// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3_0ta","signatureButtonsRight":"ModalSign_signatureButtonsRight__HlpIv"};